import { useEffect, useRef } from 'react'

import type { TristateValue } from '@/lib/permission-selection'
import { twJoin } from '@/lib/utils'

interface Props {
    value: TristateValue
    onToggle: () => void
    label: string
    disabled?: boolean
    className?: string
}

/**
 * Ô tick 3 trạng thái: chưa cấp / cấp một phần / cấp hết.
 *
 * `indeterminate` chỉ set được qua property của DOM node, không qua thuộc tính
 * HTML, nên cần ref chứ không đặt thẳng trong JSX được.
 */
export function TriStateCheckbox({
    value,
    onToggle,
    label,
    disabled,
    className,
}: Props) {
    const ref = useRef<HTMLInputElement | null>(null)

    useEffect(() => {
        if (ref.current) ref.current.indeterminate = value === 'partial'
    }, [value])

    return (
        <input
            ref={ref}
            type="checkbox"
            checked={value === 'all'}
            disabled={disabled}
            aria-label={label}
            onChange={onToggle}
            className={twJoin(
                'size-4 shrink-0 cursor-pointer accent-primary',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                'disabled:cursor-not-allowed disabled:opacity-60',
                className,
            )}
        />
    )
}
